(function() {
  function initNorthgateResellers(root) {
    if (!root || root.dataset.northgateResellersInitialized === 'true') return;
    root.dataset.northgateResellersInitialized = 'true';

    var elements = root.querySelectorAll('.nr-reveal');
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function(element) { element.classList.add('in'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    elements.forEach(function(element) { observer.observe(element); });
  }

  function initAll() {
    document.querySelectorAll('.northgate-resellers').forEach(initNorthgateResellers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initNorthgateResellers(event.target.querySelector('.northgate-resellers'));
  });
})();
